module.exports = __webpack_public_path__ + "static/p-logo--logica-4f8ab0d9011a03fa446f370535e6e00a.png";